import axios from "axios";

const API = process.env.REACT_APP_API_GO;

export const getLookupsCategory = async () => {
	const { data } = await axios.get(`${API}/app/maintainer/categories/lookups`);
	return data;
};

export const getCategories = async (filters) => {
	const { data } = await axios.get(`${API}/app/maintainer/categories/list`, { params: filters });
	return data;
};

export const getCategory = async (filters) => {
	const { data } = await axios.get(`${API}/app/maintainer/categories/detail`, { params: filters });
	return data;
};

export const saveCategory = async (payload) => {
	const { data } = await axios.post(`${API}/app/maintainer/categories/save`, payload);
	return data;
};

export const deleteCategory = async (payload) => {
	const { data } = await axios.delete(`${API}/app/maintainer/categories/delete`, { data: payload });
	return data;
};
